import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { NgSelectModule } from '@ng-select/ng-select';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatIconModule } from '@angular/material/icon';
import { FilasRoutingModule } from './filas-routing.module';
import { FilasComponent } from './filas/filas.component';
import { EditFilaComponent } from './components/edit-fila/edit-fila.component';
import { ListFilasComponent } from './components/list-filas/list-filas.component';
import { TabDadosFilaComponent } from './components/tab-dados-fila/tab-dados-fila.component';
import { TabAtendentesComponent } from './components/tab-atendentes/tab-atendente.component';
import { TabDevicesComponent } from './components/tab-devices/tab-device.component';
import { AddNewFilaComponent } from './components/add-new-fila/add-new-fila.component';
import { TabAddReasonComponent } from './components/tab-add-reason/tab-reason.component';


@NgModule({
  imports: [
    CommonModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatMenuModule,
    SharedModule,
    FilasRoutingModule,
    MatIconModule
  ],
  declarations: [
    FilasComponent,
    ListFilasComponent,
    EditFilaComponent,
    TabDadosFilaComponent,
    TabAtendentesComponent,
    TabDevicesComponent,
    AddNewFilaComponent,
    TabAddReasonComponent
  ]
})
export class FilasModule { }